export type LoginFailureKind = 'credentials' | 'deactivated' | 'network' | 'other';

export interface LoginFailure {
  kind: LoginFailureKind;
  title: string;
  message: string;
  showReset: boolean;
}

export function classifyLoginError(error: unknown): LoginFailure {
  const err = error as {
    response?: { status?: number; data?: { message?: string; code?: string } };
  };
  const status = err?.response?.status;
  const code = (err?.response?.data?.code || '').toString();
  const raw = (err?.response?.data?.message || '').toString();
  const lower = raw.toLowerCase();

  if (!err?.response || (status !== undefined && status >= 500)) {
    return {
      kind: 'network',
      title: "Can't reach the server",
      message: "We're having trouble connecting right now. Check your connection and try again.",
      showReset: false,
    };
  }

  if (code === 'ACCOUNT_DEACTIVATED' || lower.includes('deactivat')) {
    return {
      kind: 'deactivated',
      title: 'Account deactivated',
      message: 'This account is deactivated. Contact your 242 Network administrator for help signing in.',
      showReset: false,
    };
  }

  if (
    code === 'INVALID_CREDENTIALS' ||
    status === 401 ||
    lower.includes('invalid') ||
    lower.includes('incorrect')
  ) {
    return {
      kind: 'credentials',
      title: "That email or password didn't match",
      message: 'Double-check your email and password, or reset your password to get a new sign-in link.',
      showReset: true,
    };
  }

  return {
    kind: 'other',
    title: 'Sign-in failed',
    message: raw || 'Something went wrong. Please try again.',
    showReset: true,
  };
}
